import { createColumn, ColumnWidth, IMapItemCacheToColumnRendererProps } from '../createColumn';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import ColumnStrings from '../columns.resx';
import { Facet } from '../../../models/Facet';
import * as ColumnsStyles from '../columns.scss';
import { ItemFileTypeIcon } from '../../itemFileTypeIcon/ItemFileTypeIcon';
import { IFileTypeIconOptions } from '@uifabric/file-type-icons/lib/index';
import * as fileTypeIconColumnStyles from './fileTypeIconColumn.scss';
import { IItemCache } from '../../../models/IItemCacheObserver';

/**
 * @public
 */
export const fileTypeIconColumn: IColumn = createColumn({
  key: new Facet('fileTypeIconColumn').id,
  name: ColumnStrings.FileType,
  isIconOnly: true,
  iconName: 'page',
  iconClassName: `${ColumnsStyles.fileTypeIcon}`,
  className: ColumnsStyles.fileTypeIconColumn,
  headerClassName: ColumnsStyles.fileTypeIconHeader,
  fieldName: '',
  isCollapsible: false,
  isResizable: false,
  minWidth: ColumnWidth.iconMin,
  maxWidth: ColumnWidth.iconMax
}, ItemFileTypeIcon)((itemCache: IItemCache, itemKey: string | undefined) => {
  return ({ column }: IMapItemCacheToColumnRendererProps) => {
    let width = column ?
      firstNumber(column.currentWidth, column.calculatedWidth, column.minWidth) :
      undefined;

    let size: IFileTypeIconOptions['size'];

    if (typeof width === 'number') {
      if (width >= 96) {
        size = 96;
      } else if (width >= 48) {
        size = 48;
      } else if (width >= 40) {
        size = 40;
      } else if (width >= 32) {
        size = 32;
      } else if (width >= 20) {
        size = 20;
      } else {
        size = 16;
      }
    } else {
      size = ColumnWidth.iconMin;
    }

    return {
      className: fileTypeIconColumnStyles.icon,
      itemKey,
      size
    };
  };
});

function firstNumber(...values: (number | undefined)[]): number | undefined {
  for (const value of values) {
    if (typeof value === 'number') {
      return value;
    }

    return undefined;
  }
}
